import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { VerticalMenuIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuButton = styled.button.withConfig({
  displayName: "NavViewLinkActions__MenuButton",
  componentId: "sc-1n9k4sh-0"
})(["position:absolute;display:inline-flex;flex:none;width:20px;height:26px;top:4px;right:2px;border:none;border-radius:3px;background-color:transparent;justify-content:center;align-items:center;padding:0;opacity:0;transition:background-color 150ms ease;:hover{background-color:", ";}"], ({
  theme
}) => theme.color['border-core-subtle']);
const DropdownButton = ({
  onClick
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(MenuButton, {
      onClick: onClick,
      "data-test-id": "nav-view-link-actions-dropdown",
      children: /*#__PURE__*/_jsx(IconHolder, {
        color: "icon-core-subtle",
        icon: VerticalMenuIcon,
        size: "300"
      })
    })
  );
};
DropdownButton.displayName = 'DropdownButton';
const NavViewLinkActions = ({
  actions
}) => {
  return /*#__PURE__*/_jsx(Dropdown, {
    closeOnTargetLeave: true,
    Button: DropdownButton,
    placement: "right bottom",
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: actions.map(({
        disabled,
        onClick,
        disabledText,
        buttonText,
        testId
      }) => /*#__PURE__*/_jsx(Tooltip, {
        // eslint-disable-next-line conversations/no-dynamic-i18n
        title: I18n.text(disabledText),
        disabled: !disabled,
        placement: "right",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onClick,
          disabled: disabled,
          "data-test-id": testId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonText
          })
        })
      }, testId))
    })
  });
};
NavViewLinkActions.displayName = 'NavViewLinkActions';
export default NavViewLinkActions;